import IcColor from '../../../../../../../../../../../../../../../../Assets/Images/ImageEditorColor.svg'
import {useRef} from "react";
import './ImageEditorTextControl.scss'

const ImageEditorTextControl = (props) => {
  const colorInputRef = useRef(null);

  const handleOpenColorPicker = () => {
    if (colorInputRef.current) {
      colorInputRef.current.click();
    }
  }

  return (
    <div className='image-editor-text-control' style={props.WrapperStyle}>
      <div className='text-control__color'>
        <input ref={colorInputRef} className='text-control__color--input' type='color' value={props.Color} onChange={props.onChangeColor} />
        <img onClick={handleOpenColorPicker} src={IcColor} className='text-control__color--icon' alt='icon'/>
        <span>Color</span>
      </div>

      <div className='text-control__size'>
        <div className='number-input--wrapper'>
          <span className='number-input__decrement' onClick={props.onDecrement}>-</span>
          <span className='number-input__content'>{props.TextSize}</span>
          <span className='number-input__increment' onClick={props.onIncrement}>+</span>
        </div>
        <span>Size</span>
      </div>
    </div>
  );
};

export default ImageEditorTextControl;
